import React from "react";
import "./checkbox.scss";

export const Checkbox = ({ value, error, onChange = () => undefined, ...props }) => {
  return (
    <div className="platform-checkbox">
      <input
        type="checkbox"
        aria-label={props.ariaLabel}
        onChange={onChange}
        className="platform-checkbox-input"
        checked={value}
      />

      <label
        tabIndex="0"
        onKeyPress={e => {
          const keyCode = e.which || e.keyCode;
          if (keyCode === 13 || keyCode === 32) {
            onChange(!value);
          }
        }}
        onClick={() => onChange(!value)}
        onMouseDown={e => e.preventDefault()}
        className="platform-checkbox-label">
        {props.children}
      </label>
    </div>
  );
};
